const gitinfo = {
  "commit": "c6fc2342e836ded286a930e83eb0f1b537116ebb",
  "abbreviated_commit": "c6fc234",
  "tree": "e9f171ac598debca85cde7e069a07e6ffd94686d",
  "abbreviated_tree": "e9f171a",
  "parent": "0949ff9a2f662f7b0138a8f8d8cf00933924da77",
  "abbreviated_parent": "0949ff9",
  "refs": "%D",
  "encoding": "",
  "subject": "pushed by ylasi@Lenovo-PC on Wed Feb 12 07:54:37 STD 2020",
  "sanitized_subject_line": "pushed-by-ylasi-Lenovo-PC-on-Wed-Feb-12-07-54-37-STD-2020",
  "body": "",
  "commit_notes": "",
  "verification_flag": "N",
  "signer": "",
  "signer_key": "",
  "author": {
    "name": "Raz Baluchi",
    "email": "raz.baluchi@gmail.com",
    "date": "Wed, 12 Feb 2020 07:54:37 -0600"
  },
  "commiter": {
    "name": "Raz Baluchi",
    "email": "raz.baluchi@gmail.com",
    "date": "Wed, 12 Feb 2020 07:54:37 -0600"
  }
};
export default gitinfo;